var _path, _path2, _circle, _path3, _path4, _line, _mask, _path5, _mask2, _path6, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtocol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 240,
    viewBox: "0 0 350 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.28 104.11L102.05 86.54V78.98L129.28 61.41V71.49L111.15 82.62V82.9L129.28 94.03V104.11ZM184.665 104.11V94.03L202.795 82.9V82.62L184.665 71.49V61.41L211.895 78.98V86.54L184.665 104.11Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163 62L151 106",
    stroke: "currentColor",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 159,
    r: 56,
    stroke: "currentColor",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 43H297V110.596C299.891 112.82 302.57 115.305 305 118.017V43V35H297H35H27V43V196V204H35H225.195C222.077 201.622 219.203 198.94 216.619 196H35V43ZM296.805 204H297H305V196.429C302.515 199.202 299.771 201.738 296.805 204Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M278 159C278 173.847 275.805 187.113 272.383 196.524C270.666 201.246 268.716 204.786 266.752 207.07C264.777 209.368 263.157 210 262 210C260.843 210 259.223 209.368 257.248 207.07C255.284 204.786 253.334 201.246 251.617 196.524C248.195 187.113 246 173.847 246 159C246 144.153 248.195 130.887 251.617 121.476C253.334 116.754 255.284 113.214 257.248 110.93C259.223 108.632 260.843 108 262 108C263.157 108 264.777 108.632 266.752 110.93C268.716 113.214 270.666 116.754 272.383 121.476C275.805 130.887 278 144.153 278 159Z",
    stroke: "currentColor",
    strokeWidth: 8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 205,
    y1: 160,
    x2: 315,
    y2: 160,
    stroke: "currentColor",
    strokeWidth: 8
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_597_408",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.038 117.695C294.106 106.18 278.651 99 261.519 99C244.387 99 228.933 106.18 218 117.695C220.205 120.813 222.942 123.707 226.164 126.284C235.541 133.786 248.258 138 261.519 138C274.78 138 287.498 133.786 296.875 126.284C300.097 123.707 302.834 120.813 305.038 117.695Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M305.038 117.695L311.57 122.314L315.363 116.95L310.84 112.187L305.038 117.695ZM218 117.695L212.198 112.187L207.676 116.95L211.468 122.314L218 117.695ZM226.164 126.284L231.161 120.037L231.161 120.037L226.164 126.284ZM296.875 126.284L291.877 120.037L291.877 120.037L296.875 126.284ZM261.519 107C276.368 107 289.752 113.213 299.237 123.203L310.84 112.187C298.46 99.1471 280.934 91 261.519 91V107ZM223.802 123.203C233.287 113.213 246.671 107 261.519 107V91C242.104 91 224.579 99.1471 212.198 112.187L223.802 123.203ZM211.468 122.314C214.128 126.076 217.39 129.51 221.166 132.531L231.161 120.037C228.493 117.903 226.282 115.551 224.532 113.076L211.468 122.314ZM221.166 132.531C232.111 141.287 246.643 146 261.519 146V130C249.874 130 238.97 126.284 231.161 120.037L221.166 132.531ZM261.519 146C276.395 146 290.927 141.287 301.872 132.531L291.877 120.037C284.068 126.284 273.165 130 261.519 130V146ZM301.872 132.531C305.648 129.51 308.911 126.076 311.57 122.314L298.506 113.076C296.757 115.551 294.545 117.903 291.877 120.037L301.872 132.531Z",
    fill: "currentColor",
    mask: "url(#path-7-inside-1_597_408)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-2_597_408",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.038 198.695C294.106 187.18 278.651 180 261.519 180C244.387 180 228.933 187.18 218 198.695C220.205 201.813 222.942 204.707 226.164 207.284C235.541 214.786 248.258 219 261.519 219C274.78 219 287.498 214.786 296.875 207.284C300.097 204.707 302.834 201.813 305.038 198.695Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M305.038 198.695L311.57 203.314L315.363 197.95L310.84 193.187L305.038 198.695ZM218 198.695L212.198 193.187L207.676 197.95L211.468 203.314L218 198.695ZM226.164 207.284L231.161 201.037L231.161 201.037L226.164 207.284ZM296.875 207.284L291.877 201.037L291.877 201.037L296.875 207.284ZM261.519 188C276.368 188 289.752 194.213 299.237 204.203L310.84 193.187C298.46 180.147 280.934 172 261.519 172V188ZM223.802 204.203C233.287 194.213 246.671 188 261.519 188V172C242.104 172 224.579 180.147 212.198 193.187L223.802 204.203ZM211.468 203.314C214.128 207.076 217.39 210.51 221.166 213.531L231.161 201.037C228.493 198.903 226.282 196.551 224.532 194.076L211.468 203.314ZM221.166 213.531C232.111 222.287 246.643 227 261.519 227V211C249.874 211 238.97 207.284 231.161 201.037L221.166 213.531ZM261.519 227C276.395 227 290.927 222.287 301.872 213.531L291.877 201.037C284.068 207.284 273.165 211 261.519 211V227ZM301.872 213.531C305.648 210.51 308.911 207.076 311.57 203.314L298.506 194.076C296.757 196.551 294.545 198.903 291.877 201.037L301.872 213.531Z",
    fill: "currentColor",
    mask: "url(#path-9-inside-2_597_408)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 134,
    x2: 157,
    y2: 134,
    stroke: "currentColor",
    strokeWidth: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 168,
    x2: 129,
    y2: 168,
    stroke: "currentColor",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtocol);
export default __webpack_public_path__ + "static/media/protocol.68672c12bb34493997bf4be1f92b2ead.svg";
export { ForwardRef as ReactComponent };